import type { ActionItem } from '../../types'

// Task #459: shared created-date + carryover history block, shown in the
// Team page action item modal and the meeting accountability detail view.
export default function ActionItemHistory({ item }: { item: ActionItem }) {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00')
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
  }

  const carryovers = item.carryovers || []

  return (
    <div data-testid={`action-item-history-${item.id}`}>
      <h4 className="text-sm font-semibold text-text-primary uppercase tracking-wider mb-2">History</h4>
      <div className="space-y-1.5">
        <div className="flex items-center gap-2 text-sm text-text-primary">
          <svg className="w-4 h-4 flex-shrink-0 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          <span>Created {formatDate(item.created_at)}</span>
        </div>
        {carryovers.length === 0 ? (
          <div className="flex items-center gap-2 text-sm text-text-muted italic">
            <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
            <span>Never carried over</span>
          </div>
        ) : (
          carryovers.map(c => (
            <div key={c.id} className="flex items-center gap-2 text-sm" style={{ color: '#B8860B' }}>
              <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
              <span>Carried over {formatDate(c.carried_over_on)}</span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
